<script>
export default {
name: "LoadLabelMixin"
  ,
  data() {
    return {
      project_id: false
    }
  },
  mounted() {
    this.load_labels();
  },
  computed: {
    labels () {
      return this.$store.getters['label/get_items']
    },
    label_names() {
      return this.labels.map(label=>{return label.name});
    },
    labels_dict() {
      return Object.assign({}, ...this.labels.map((x) => ({[x.id]: x})));
    },
    point_labels() {
      return this.labels.filter(label=>{return label.type == 2; })
    },
    box_labels() {
      return this.labels.filter(label=>{return label.type != 2; })
    },
    labels_loaded() {
      return this.$store.getters['label/get_loaded']
    },
    labels_loading() {
      return this.$store.getters['label/get_loading']
    },
    loaded_for_project_id() {
      return this.$store.getters['label/get_loaded_for_project_id']
    }

  },
  methods: {
    async load_labels() {
      // Check if labels are already loaded for the current project
      if (this.force_label_reload !== true && this.loaded_for_project_id === this.$store.state.project.project_id && this.labels_loaded) {
        return;
      }
      
      // Set loading state
      this.$store.commit('label/SET_LOADING', true);
      
      try {
        await this.$store.dispatch('label/all', {force_reload: this.force_label_reload, in_batches: true});
        
        // Update store state
        this.$store.commit('label/SET_LOADED', true);
        this.$store.commit('label/SET_LOADED_FOR_PROJECT_ID', this.$store.state.project.project_id);
      } finally {
        // Clear loading state
        this.$store.commit('label/SET_LOADING', false);
      }
    },
    
    // Method to ensure labels are loaded (for lazy loading scenarios)
    async ensure_labels_loaded() {
      if (!this.labels_loaded || this.loaded_for_project_id !== this.$store.state.project.project_id) {
        await this.load_labels();
      }
      return this.labels_loaded;
    }
  }
}
</script>

<style scoped>

</style>